import React from "react";

export function Exitbtn({...props}) {
     return (
          <a  {...props} class="btn btn-lg" style={{ backgroundColor: "#2f56a1", color: "white", width: "150px" }}>Exit</a>
     );
}
